var DeliveryOptionsView = (function (Backbone, BaseView) {
    var PackageView = Backbone.View.extend({
        events: {
            'click': '_select'
        },
        initialize: function () {
            _.bindAll(this, '_toggleSelected', '_select');
            this.$el = $.tmpl('deliveryOptionPackage', this.model.toJSON());
            this._toggleSelected();
            this.listenTo(this.model, 'change:Selected', this._toggleSelected);
        },

        _select: function (e) {
            e.stopPropagation();
            this.model.select();
        },

        _toggleSelected: function () {
            var isSelected = this.model.get('Selected');
            this.$el.toggleClass('radio-sw-item__selected', isSelected);
            this.$('@deliveryOption-package-icon').toggleClass('radio-sw-item-button_icon__selected', isSelected);
        }
    });

    var PackagesView = Backbone.View.extend({
        initialize: function () {
            _.bindAll(this, '_addOption');
            this._render();
            this.listenTo(this.collection, 'add', this._addOption);
        },

        _render: function () {
            this.collection.each(this._addOption);
        },

        _addOption: function (model) {
            var option = new PackageView({ model: model });
            this.$el.append(option.$el);
        }
    });


    var DeliveryOptionView = BaseView.extend({
        events: {
            'click': '_select',
            'click @ops-info-popup': '_display_ops_info_popup'
        },
        initialize: function () {
            _.bindAll(this, '_toggleSelected', '_select', '_updateDescription');
            this.$el = $.tmpl('deliveryOptionContainer', this.model.toJSON());
            this._init();
            this.listenTo(this.model, 'change:Selected', this._toggleSelected);
            this.listenTo(this.model, 'change:IsDeleted', this._toggle);
            this.listenTo(this.model, 'change:Purchased', this._init);
            this.listenTo(this.model, 'change:AgreedWithTerms', this._init);
            this.listenTo(this.model, 'change:Price', this._init);
            this.listenTo(this.model, 'change:IsAvailable', this._toggleAvailable);
            this.listenTo(this.model, 'change:Description', this._updateDescription);
            this.listenTo(this.model, 'change:Info', this._updateInfo);
            this.listenTo(this.model, 'change:Title', this._updateTitle);
        },

        _init: function () {
            this.$el.html($.tmpl('deliveryOption', this.model.toJSON()));
            this.$deliveryOption_packages = this.$('@deliveryOption-packages');
            this.$deliveryOption_terms = this.$('@deliveryOption-terms-check-block');
            this._toggleSelected();
            this._toggleAvailable();
            this._renderPackages();
            this.model.set('AgreedWithTerms', true);
        },

        _renderPackages: function () {
            !this.model.get('Purchased') &&
                this.model.get('Packages') !== null &&
                new PackagesView({ el: this.$deliveryOption_packages, collection: this.model.get('Packages') });
            this.$('@ops-info-popup').toggleClass('hidden-block', this.model.get('Purchased') || false);
        },

        _select: function (e) {
            e.stopPropagation();
            var isAvailable = this.model.get('IsAvailable');
            if (isAvailable) {
                this.model.select();
            }
        },

        _toggleSelected: function () {
            var isSelected = this.model.get('Selected');
            this.$el.toggleClass('radio-sw-item__selected', isSelected);
            this.$('@deliveryOption-icon').toggleClass('radio-sw-item-button_icon__selected', isSelected);
            this.$deliveryOption_packages.toggleClass('hidden-block', !isSelected);
            this.$deliveryOption_terms.toggleClass('hidden-block', !isSelected || !!this.model.get('Purchased'));
        },

        _updateTitle: function () {
            var title = this.model.get('Title');
            this.$('@delivery-option-title').text(title || '');
        },

        _updateInfo: function () {
            var info = this.model.get('Info');
            this.$('@delivery-option-info').text(info || '');
        },

        _toggleAvailable: function () {
            var isAvailable = this.model.get('IsAvailable');
            this.$el.toggleClass('radio-sw-disabled', !isAvailable);
        },

        _updateDescription: function() {
            this.$('@DeliveryOptionDescription').text(this.model.get('Description'));
        },

        _toggle: function () {
            var isOptionHidden = this.model.get('IsDeleted') || !this.model.get('IsVisible');
            this.$el.toggleClass('hidden-block', isOptionHidden);
        },

        _display_ops_info_popup: function (e) {
            e.stopPropagation();
            window.app && app.event && app.event.selectMoreDetails();
            var _this = this;
            this.model.get('Packages').ready(function () {
                _this.display('checkout.ops.info', { packages: _this.model.get('Packages').map(function (m) { return m.toJSON(); }) });
            });
        }
    });

    var DeliveryOptionsView = BaseView.extend({

        displayRoutes: ['checkout.delivery.options'],

        initialize: function () {
            _.bindAll(this, '_addOption', '_toggle');

            this.$el = $.tmpl('deliveryOptions');
            this._toggle();

            $('@delivery-options').replaceWith(this.$el);

            this._render();
            this.listenTo(this.collection, 'add', this._addOption);
            this.listenTo(this.collection, 'saved', this._saved);
        },

        _render: function () {
            this.collection.each(this._addOption);
        },

        _addOption: function (model) {           
            var option = new DeliveryOptionView({ model: model });
            this.$el.append(option.$el);
            option._toggle();
        },

        _toggle: function () {
            this.$el.toggleClass('hidden-block', !(this.collection.length > 1));
        },

        _saved: function () {
            this.display('checkout');
        }
    });

    return DeliveryOptionsView;
})(Backbone, BaseView);

var DeliveryOptionsButtonView = (function (BaseView) {
    return BaseView.extend({
        el: '@delivery-options-button-block',

        hiddenClass: 'hidden-block',

        events: {
            'click @delivery-options-button': 'displayDeliveryOptions'
        },

        initialize: function () {
            _.bindAll(this, 'render', 'displayDeliveryOptions');

            this.$el.addClass(this.hiddenClass);
            this.$content = this.$('@delivery-options-button');
            this.listenTo(this.model, 'change', this.render);
        },

        render: function () {
            var deliveryOptions = this.model.get('DeliveryOptions');
            var availableOptionsCount = deliveryOptions.length;
            var visibleOptionsCount = deliveryOptions.where({IsVisible : true}).length;
            var packageDetails = this.model.get('DeliveryServicePackageDetail').toJSON();
            var display = availableOptionsCount > 1 && visibleOptionsCount > 1;

            if (display) {
                var selectedOption = deliveryOptions.where({ Selected: true });
                selectedOption = selectedOption[0];
                this.$content.html($.tmpl('deliveryOptionButton', $.extend({}, selectedOption.toJSON(), { packageDetails: packageDetails })));
            }
            this.$el.toggleClass(this.hiddenClass, !display);
        },

        displayDeliveryOptions: function (e) {
            e.preventDefault();
            this.display('checkout.delivery.options');
        }
    });
})(BaseView);